
function activateYassoSpecificTab(tabElement) {
  if (!tabElement) return;

  const tabsContainer = tabElement.closest(
    '[data-yasso-tabs-container]'
  );
  if (!tabsContainer) return;

  const targetPanelId = tabElement.getAttribute('data-tab-target');
  const targetPanel = document.getElementById(targetPanelId);

  if (!targetPanel) return;

  const tabLinks = tabsContainer.querySelectorAll(
    '.yasso-explore-products__tab'
  );

  const tabPanels = tabsContainer.querySelectorAll(
    '.yasso-explore-products__panel'
  );

  tabLinks.forEach(function (tab) {
    const isActive = tab === tabElement;

    tab.classList.toggle('is-active', isActive);
    tab.setAttribute('aria-selected', String(isActive));
  });

  tabPanels.forEach(function (panel) {
    panel.classList.toggle('is-active', panel === targetPanel);
  });
}

function normalizePath(url) {
  const parsedUrl = new URL(url, window.location.origin);

  // Ignore trailing slashes when comparing URLs.
  return parsedUrl.pathname.replace(/\/+$/, '') || '/';
}

function syncSpecificTabWithUrl() {
  const currentPath = normalizePath(window.location.href);

  document.querySelectorAll('[data-yasso-tabs-container]').forEach(
    function (container) {
      const tabs = container.querySelectorAll(
        '.yasso-explore-products__tab'
      );

      let matchedTab = null;

      tabs.forEach(function (tab) {
        const href = tab.getAttribute('href');

        if (!href || href === '#') return;

        const tabPath = normalizePath(href);

        if (tabPath === currentPath) {
          matchedTab = tab;
        }
      });

      if (matchedTab) {
        activateYassoSpecificTab(matchedTab);
      }
    }
  );
}

// Video hover functionality
function initializeYassoVideoHover() {
  const videos = document.querySelectorAll(
    '.yasso-explore-products__video'
  );

  videos.forEach(function (video) {
    // Prevent duplicate event listeners if initialization runs again.
    if (video.dataset.hoverInitialized === 'true') return;

    video.dataset.hoverInitialized = 'true';

    video.addEventListener('mouseenter', function () {
      this.currentTime = 0;

      const playPromise = this.play();

      if (playPromise !== undefined) {
        playPromise.catch(function (error) {
          console.warn('Yasso product video playback failed:', error);
        });
      }
    });
  });
}

// Initialize tab selection and videos
function initializeYassoExploreProducts() {
  syncSpecificTabWithUrl();
  initializeYassoVideoHover();
}

if (document.readyState === 'loading') {
  document.addEventListener(
    'DOMContentLoaded',
    initializeYassoExploreProducts
  );
} else {
  initializeYassoExploreProducts();
}
